import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Sauna = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="sauna"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M35.437 37.039a3.02 3.02 0 00-2.694-1.654h-8.835V33.37h7.604a2.268 2.268 0 100-4.537h-7.604V22a4.537 4.537 0 00-9.074 0v14.886a4.537 4.537 0 004.537 4.537l11.517.012 6.058 11.911a3.023 3.023 0 004.067 1.325 3.022 3.022 0 001.324-4.067l-6.9-13.564zM19.37 15.302a5.152 5.152 0 10-.003-10.304 5.152 5.152 0 00.003 10.304z" />
      <path d="M26.685 44.287H14.621a3.517 3.517 0 000 7.034h12.064a3.517 3.517 0 000-7.034zM39.072 33.773c3.283-1.296 2.527-6.564 2.419-7.543-.115-.96-1.368-5.695-.237-7.218-3.326 1.17-2.54 6.236-2.377 7.866.21 2.102 1.413 4.985.195 6.895zM46.326 23.3c3.283-1.296 2.527-6.564 2.419-7.543-.115-.959-1.368-5.694-.237-7.217-3.326 1.17-2.54 6.236-2.378 7.866.21 2.101 1.414 4.985.196 6.894zM48.508 30c-3.326 1.17-2.54 6.236-2.378 7.866.21 2.102 1.414 4.985.196 6.895 3.283-1.296 2.527-6.564 2.419-7.543-.115-.96-1.368-5.695-.237-7.218z" />
    </svg>
  );
};
/* eslint-enable max-len */

Sauna.defaultProps = {
  className: null,
};

Sauna.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Sauna;
